import { api } from 'apis/base'

export type MultipartStartResponse = {
  upload_id: string
  key: string
}
export function multipartStart(params: { key: string, content_type: string }) {
  return api<MultipartStartResponse>({
    method: 'POST',
    url: '/videos/multipart_start',
    params
  })
}

export type MultipartPresignResponse = {
  presigned_url: string
}
export function multipartPresign(params: { key: string; upload_id: string; part_number: number }) {
  return api<MultipartPresignResponse>({
    method: 'GET',
    url: '/videos/multipart_presign',
    params
  })
}

export type MultipartCompleteResponse = {
  status: string
  location: string
}

export function multipartComplete(params: { key: string; upload_id: string; parts: { ETag: string; PartNumber: number }[] }) {
  return api<MultipartCompleteResponse>({
    method: 'POST',
    url: '/videos/multipart_complete',
    data: params
  })
}
